import { facilityStayAction } from '../../actions/constant';

const {
  SUCCESS_GET_ALL_FACILITIES_STAY,
  FAILURE_GET_ALL_FACILITIES_STAY,
  LOADER_GET_ALL_FACILITIES_STAY,
} = facilityStayAction;

const initialState: object = {
  isGetFacilitiesStay: false,
  response: null,
  loader: false,
};

export const getAllFacilitiesStaysReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_FACILITIES_STAY: {
      return {
        ...state,
        isGetFacilitiesStay: true,
        response: action.payload,
        loader: false,
      };
    }

    case FAILURE_GET_ALL_FACILITIES_STAY:
      return {
        ...state,
        isGetFacilitiesStay: false,
        response: action.payload,
        loader: false,
      };
    case LOADER_GET_ALL_FACILITIES_STAY:
      return {
        ...state,
        loader: true,
      };

    default:
      return state;
  }
};
